import Calendar from "../Calendar";

export default class ChangeViewUseCase {
  public static changeView(targetViewId: string, calendar: Calendar): Array<Date> {
    calendar.changeView(targetViewId);
    return targetViewId === calendar.getMonthViewId() ? [] : calendar.getDateRange();
  }
}
